import { User } from "@/models"
import { ApiService } from "@/services"

export class UsersService extends ApiService {
	constructor() {
		super("/api/users")
	}

	async list() {
		return await this.returning(User.array()).get("")
	}

	async update(user: User) {
		return await this.returning(User).put("", user)
	}

	async getAccount() {
		return await this.returning(User).get("/api/account")
	}
}
